import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  DropDown,
  RollingLoader,
  Checkbox,
  RadioContainer,
} from "../../commons";
import { returnInputFieldLength } from "../../../utils/commonFunctions";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  checkUniqueLedgerAction,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  getSingleTypeLedgerListAction,
  resetSingleTypeLedgersList,
} from "../../../redux/clientSettings";
import {
  CheckUniqueLedgerPayloadType,
  GetAllLedgersListPayloadType,
} from "../../../commonTypes/clientSettingsTypes";
import { AllLedgersListType } from "../../../redux/clientSettings/clientSettingTypes";
import "./AccountsModal.scss";
import Select, { OptionProps, components } from "react-select";

type RadioTypes = {
  id: string;
  name: string;
};

type AccountDetailsType = {
  accountName?: string;
  accountNumber?: string;
};

type AccountDetailsErrorType = {
  accountNameError: string;
  accountNumberError: string;
  isUniqueError: boolean;
  parentAccountError: string;
};

type ModeType = {
  value: string;
  label: string;
};

type FinalAccountDetailsType = {
  accountName?: string;
  accountNumber?: string;
  ledger_type?: string;
};

const MODE_TYPE: ModeType[] = [
  {
    value: "nature_of_expense",
    label: "Expense",
  },
  {
    value: "nature_of_income",
    label: "Income",
  },
  {
    value: "payment",
    label: "Cash & Cash Equivalents",
  },
  {
    value: "assets",
    label: "Assets",
  },
  {
    value: "liabilities",
    label: "Liabilities",
  },
  {
    value: "equity",
    label: "Equity",
  },
];

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    name: "Yes",
  },
  {
    id: "0",
    name: "No",
  },
];

const ACCOUNT_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    name: "Direct",
  },
  {
    id: "2",
    name: "Indirect",
  },
];

type AppProps = {
  token: string | null;
  success: number | null;
  error: string | null;
  isOpen: boolean;
  client_code: number | null;
  uniqueLedgerFetching: boolean;
  ledgerMessage: string | null;
  allLedgersList: AllLedgersListType[] | [];
  // editAccountDetailsData?: AllLedgersListType;
  editAccountDetailsData?: any;
  isEdit?: boolean;
  toggleAddFolderModal: () => void;
  handleAddAccountDetails: (data: FinalAccountDetailsType) => void;
  handleEditAccountDetails: (data: any) => void;
  handleResetEditData: () => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchCheckUniqueLedgerAction: (data: CheckUniqueLedgerPayloadType) => void;
  dispatchGetAllLedgersListAction: (data: GetAllLedgersListPayloadType) => void;
  dispatchResetSingleTypeLedgerListAction: () => void;
  autoUniqueNumberGenerationData: any;
  dispatchResetAutoUniqueNumberGenerationData: () => void;

};

const AddAccountModal = ({
  token,
  success,
  error,
  isEdit,
  allLedgersList,
  editAccountDetailsData,
  uniqueLedgerFetching,
  client_code,
  ledgerMessage,
  dispatchCheckUniqueLedgerAction,
  dispatchGetAllLedgersListAction,
  dispatchResetSingleTypeLedgerListAction,
  handleResetEditData,
  isOpen,
  toggleAddFolderModal,
  handleAddAccountDetails,
  handleEditAccountDetails,
  autoUniqueNumberGenerationData,
  dispatchResetAutoUniqueNumberGenerationData,
}: AppProps) => {
  const [accountDetails, setAccountDetails] = useState<AccountDetailsType>({
    accountName: "",
    accountNumber: "",
  });

  const [accountDetailsError, setAccountDetailsError] =
    useState<AccountDetailsErrorType>({
      accountNameError: "",
      accountNumberError: "",
      isUniqueError: false,
      parentAccountError: "",

    });

  const [modeSelected, setModeSelected] = useState<any>({
    value: null,
    label: 'Select Account Type...',
  });
  const [parentAccount, setParentAccount] = useState<any>({
    value: null,
    label: "Select Parent Account...",
    cog: ""
  });

  const { accountName, accountNumber } = accountDetails;
  const { accountNameError, accountNumberError } = accountDetailsError;
  const [ledgerApiMessage, setLedgerApiMessage] = useState<string>("");
  const [toShowSubAccount, setToShowSubAccount] = useState<boolean>(false);
  const [toShowLedger, setToShowLedger] = useState<string>(RADIO_OPTIONS[0].id);
  const [costOfGoods, setCostOfGoods] = useState<string>(ACCOUNT_RADIO_OPTIONS[0].id);
  const [finalLedgerList, setFinalLedgerList] = useState<any>([]);
  const [ledgerType, setLedgerType] = useState<string>("");
  const [manipulatedData, setManipulatedData] = useState<any>([]);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [isCostOfGoodChange, setIsCostOfGoodChange] = useState(false);
  const [autoUniqueNumberCheck, setAutoUniqueNumberCheck] = useState<boolean>(false);

  useEffect(() => {
    dispatchResetSingleTypeLedgerListAction();
    setManipulatedData([]);
    setFinalLedgerList([]);
    // dispatchResetAutoUniqueNumberGenerationData();
    if (token && client_code && isEdit) {
      let finalData = {
        client_code,
        token,
        ledger_type: isEdit && editAccountDetailsData?.ledger_tech_type,
      };

      dispatchGetAllLedgersListAction(finalData);
    }
     //eslint-disable-next-line
  }, []);
    useEffect(() => {
      if(autoUniqueNumberGenerationData && Object.keys(autoUniqueNumberGenerationData)?.length > 0){
        setAutoUniqueNumberCheck(autoUniqueNumberGenerationData?.is_enable === 1);
      } else {
        setAutoUniqueNumberCheck(false);
      }
    }, [autoUniqueNumberGenerationData, autoUniqueNumberCheck])

  useEffect(() => {

    if (!isEdit) {
      if (modeSelected?.value === "nature_of_income") {
        setCostOfGoods(ACCOUNT_RADIO_OPTIONS[0].id)
      }
      else if (modeSelected?.value === "nature_of_expense") {
        setCostOfGoods(ACCOUNT_RADIO_OPTIONS[1].id)
      }
    }

    else if (isEdit && isCostOfGoodChange) {
      if (modeSelected?.value === "nature_of_income") {
        setCostOfGoods(ACCOUNT_RADIO_OPTIONS[0].id)
      }
      else if (modeSelected?.value === "nature_of_expense") {
        setCostOfGoods(ACCOUNT_RADIO_OPTIONS[1].id)

      }
    }
     //eslint-disable-next-line
  }, [modeSelected, isCostOfGoodChange])

  const manipulateLedgerData = () => {
    let finalManipulatedData: any = [];
    allLedgersList &&
      allLedgersList?.length > 0 &&
      allLedgersList?.map((tempData: any) => {
        if (!tempData?.to_show) {
          finalManipulatedData.push({
            ledger_name: tempData?.ledger_name,
            ledger_id: tempData?.ledger_id,
            parent_id: tempData?.parent_id,
          });
        }
        if (tempData?.is_tree) {
          tempData?.tree_data?.map((tree: any) => {
            if (!tree?.to_show) {
              finalManipulatedData.push({
                ledger_name: tree?.ledger_name,
                ledger_id: tree?.ledger_id,
                parent_id: tree?.parent_id,
              });
            }
            if (tree?.is_tree) {
              tree?.tree_data?.map((treeD: any) => {
                if (!treeD?.to_show) {
                  finalManipulatedData.push({
                    ledger_name: treeD?.ledger_name,
                    ledger_id: treeD?.ledger_id,
                    parent_id: treeD?.parent_id,
                  });
                }
                if (!treeD?.is_tree) {
                  treeD?.tree_data?.map((treeD1: any) => {
                    finalManipulatedData.push({
                      ledger_name: treeD1?.ledger_name,
                      ledger_id: treeD1?.ledger_id,
                      parent_id: treeD1?.parent_id,
                    });
                  });
                }
              });
            }
          });
        }
      });

    setManipulatedData(finalManipulatedData);
  };

  // Call Mainpulate Data function
  useEffect(() => {
    manipulateLedgerData();
     //eslint-disable-next-line
  }, [allLedgersList]);

  // Checking unique ledger number
  useEffect(() => {
    if (ledgerMessage?.length) {
      setLedgerApiMessage(ledgerMessage);
    }

    if (ledgerMessage?.length && ledgerMessage?.includes("not")) {
      setAccountDetailsError((prevState) => ({
        ...prevState,
        isUniqueError: true,
      }));
    } else if (ledgerMessage?.length && !ledgerMessage?.includes("not")) {
      setAccountDetailsError((prevState) => ({
        ...prevState,
        isUniqueError: false,
      }));
    }
  }, [ledgerMessage]);

  // Edit Account Details
  useEffect(() => {
    if (isEdit) {
      const { accountNumberError } = accountDetailsError;
      if (accountNumberError) {
        setAccountDetailsError((prevState) => ({
          ...prevState,
          accountNumberError: "",
        }));
      }
      setAccountDetails((prevState) => ({
        ...prevState,
        accountName: editAccountDetailsData?.ledger_name,
        accountNumber: editAccountDetailsData?.ledger_number?.toString(),
      }));

      setModeSelected({
        value: isEditMode && modeSelected?.value !== editAccountDetailsData?.ledger_tech_type ? modeSelected?.value : editAccountDetailsData?.ledger_tech_type,
        label: isEditMode && modeSelected?.value !== editAccountDetailsData?.ledger_tech_type ? modeSelected?.label : MODE_TYPE.filter(
          (mode) => mode.value === editAccountDetailsData?.ledger_tech_type
        )[0].label,
      });
      setCostOfGoods(editAccountDetailsData?.cog_type === 2 ? ACCOUNT_RADIO_OPTIONS[1].id : ACCOUNT_RADIO_OPTIONS[0].id)
      setLedgerType(editAccountDetailsData?.ledger_tech_type);

      setToShowLedger(
        editAccountDetailsData?.to_show === 0
          ? RADIO_OPTIONS[1].id
          : RADIO_OPTIONS[0].id
      );

      if (
        manipulatedData &&
        manipulatedData?.length > 0 &&
        editAccountDetailsData?.parent_id
      ) {
        let finalLabel = manipulatedData?.filter(
          (data: any) => data?.ledger_id === editAccountDetailsData?.parent_id
        );

        if (finalLabel?.[0]?.ledger_name) {
          setParentAccount({
            value: editAccountDetailsData?.parent_id ?? 0,
            label: finalLabel?.[0].ledger_name,
            cog: editAccountDetailsData?.cog_type
          });
        } else {
          setParentAccount({
            value: null,
            label: "Select Parent Account...",
            cog: ""
          });
        }

        setToShowSubAccount(true);
      }
      setIsEditMode(true);
    }
     //eslint-disable-next-line
  }, [isEdit, manipulatedData]);

  useEffect(() => {
    renderDropdownList();
     //eslint-disable-next-line
  }, [allLedgersList]);

  const renderDropdownList = () => {
    let finalDropDownData: any = [];
    allLedgersList?.map((tempData: any) => {
      if (!tempData?.to_show) {
        finalDropDownData?.push({
          level: 1,
          value: tempData?.ledger_id,
          label: tempData?.ledger_name,
          cog: tempData?.cog_type
        });
      }
      if (tempData?.is_tree) {
        tempData?.tree_data?.map((tree: any) => {
          if (!tree?.to_show) {
            finalDropDownData?.push({
              level: 2,
              value: tree?.ledger_id,
              label: tree?.ledger_name,
              cog: tempData?.cog_type
            });
          }
          if (tree?.is_tree) {
            tree?.tree_data?.map((treeD: any) => {
              if (!treeD?.to_show) {
                finalDropDownData?.push({
                  level: 3,
                  value: treeD?.ledger_id,
                  label: treeD?.ledger_name,
                  cog: tempData?.cog_type
                });
              }
              if (treeD?.is_tree) {
                treeD?.tree_data?.map((treeD1: any) => {
                  if (!treeD1?.to_show) {
                    finalDropDownData?.push({
                      level: 4,
                      value: treeD1?.ledger_id,
                      label: treeD1?.ledger_name,
                      cog: tempData?.cog_type
                    });
                  }
                });
              }
            });
          }
        });
      }
    });

    setFinalLedgerList(finalDropDownData);
  };

  useEffect(() => {
    if (!toShowSubAccount) {
      setParentAccount({
        value: null,
        label: "Select Parent Account..",
        cog: ""
      });
    }
  }, [toShowSubAccount]);

  const toggleCheckbox = () => {
    setAccountDetailsError({
      accountNameError: "",
      accountNumberError: "",
      isUniqueError: false,
      parentAccountError: "",
    })
    setToShowSubAccount(!toShowSubAccount);
  };

  const handleMaxLengthCheck = (e: any) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
      setAccountDetails((prevState) => ({
        ...prevState,
        accountNumber: e.target.value,
      }));
    }
  };

  const handleAccountDetailsChange = (e: any) => {
    const { accountNameError, accountNumberError } = accountDetailsError;
    let targetName = e.target.name;
    setAccountDetailsError({
      accountNameError: "",
      accountNumberError: "",
      isUniqueError: false,
      parentAccountError: "",
    })
    if (targetName === "accountNumber" && e.target.value.length) {
      let finalData = {
        token,
        client_code,
        ledger_number: e.target.value,
      };
      if (!isEdit) {
        dispatchCheckUniqueLedgerAction(finalData);
      } else if (
        isEdit &&
        targetName === "accountNumber" &&
        e.target.value != editAccountDetailsData?.ledger_number
      ) {
        dispatchCheckUniqueLedgerAction(finalData);
      }
    }

    if (targetName === "accountName") {
      setAccountDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    } else {
      setAccountDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }

    if (targetName === "accountNumber" && accountNumberError) {
      setAccountDetailsError((prevState) => ({
        ...prevState,
        accountNumberError: "",
      }));
    } else if (targetName === "accountName" && accountNameError) {
      setAccountDetailsError((prevState) => ({
        ...prevState,
        accountNameError: "",
      }));
    }
  };

  // Submit Account Details (Add/Edit)
  const handleSubmitAccountDetails = () => {
    const { accountNumber, accountName } = accountDetails;
    const { isUniqueError } = accountDetailsError;

    if (accountName && (accountNumber || autoUniqueNumberCheck) && !isUniqueError) {
      if (isEdit) {
        let finalEditData = {
          ...accountDetails,
          ledger_type: modeSelected?.value,
          ledger_id: editAccountDetailsData?.ledger_id,
          ...(parentAccount?.value && { parent_id: parentAccount?.value }),
          to_show: toShowLedger,
          cog_type: parentAccount?.value ? +parentAccount?.cog : +costOfGoods,
          is_tree: editAccountDetailsData?.is_tree
        };

        handleEditAccountDetails(finalEditData);
        handleResetData();
      } else {
        let finalAddData = {
          ...accountDetails,
          ledger_type: modeSelected?.value,
          ...(parentAccount?.value && { parent_id: parentAccount?.value }),
          to_show: toShowLedger,
          cog_type: parentAccount?.value ? +parentAccount?.cog : +costOfGoods
        };

        handleAddAccountDetails(finalAddData);
      }
    } else {
      setAccountDetailsError((prevState) => ({
        ...prevState,
        ...(!accountNumber && {
          accountNumberError: "Account number is required!",
        }),
        ...(!accountName && { accountNameError: "Account name is required!" }),
        ...(!parentAccount?.value && {
          parentAccountError: "Choose parent account!",
        }),
      }));
    }
  };

  // Setting Account Type
  const handleChangeSelectedMode = (mode: any) => {
    setIsCostOfGoodChange(true)
    setAccountDetailsError({
      accountNameError: "",
      accountNumberError: "",
      isUniqueError: false,
      parentAccountError: "",
    })
    setModeSelected(mode);
    setLedgerType(mode?.value);

    if (mode?.value !== ledgerType) {
      setParentAccount({
        value: null,
        label: 'Select Parent Account...',
        cog: ""
      })
    }

    if (client_code && token) {
      let finalData = {
        client_code,
        token,
        ledger_type: mode?.value,
      };
      dispatchGetAllLedgersListAction(finalData);
    }
  };

  // Set Parent Account
  const handleChangeParentAccount = (parentAccountData: any) => {
    setParentAccount({
      value: parentAccountData?.value,
      label: parentAccountData?.label,
      cog: parentAccountData?.cog
    });

    if (
      isEdit &&
      parentAccountData?.value === editAccountDetailsData?.ledger_id
    ) { 
      setAccountDetailsError((prevState) => ({
        ...prevState,
        parentAccountError: "Parent Account cannot be same as Current Account!",
      }));
    } else if (accountDetailsError?.parentAccountError) {
      setAccountDetailsError((prevState) => ({
        ...prevState,
        parentAccountError: "",
      }));
    }

    if (parentAccountData?.level === 4) {
      setAccountDetailsError((prevState) => ({
        ...prevState,
        parentAccountError:
          "Sub-account cannot be created for this parent account!",
      }));
    } else if (accountDetailsError?.parentAccountError) {
      setAccountDetailsError((prevState) => ({
        ...prevState,
        parentAccountError: "",
      }));
    }
  };

  const handleSetRadioValue = (radioValue: string) => {
    setToShowLedger(radioValue);
  };

  const handleSetCostOfGoodsRadioValue = (radioValue: string) => {
    setCostOfGoods(radioValue);
  };

  // Resetting All Data
  const handleResetData = () => {
    dispatchResetSingleTypeLedgerListAction();
    setAccountDetails((prevState) => ({
      ...prevState,
      accountName: "",
      accountNumber: "",
    }));

    setAccountDetailsError((prevState) => ({
      ...prevState,
      accountNameError: "",
      accountNumberError: "",
    }));

    setManipulatedData([]);
    setFinalLedgerList([]);
    setParentAccount({
      value: null,
      label: "Select Parent Account...",
      cog: ""
    });
    setLedgerType("");
    setModeSelected({
      value: MODE_TYPE[0].value,
      label: MODE_TYPE[0].label,
    });
    setToShowLedger(RADIO_OPTIONS[0].id);
    setIsEditMode(false);
  };

  // Formatting Parent Account Dropdowns
  const Option = (props: OptionProps<AllLedgersListType, false>) => {
    return (
      <components.Option {...props}>
        <ul
          className={`ledger-list ${props.data.level === 1
            ? "ledger-list-first"
            : props.data.level === 2
              ? "ledger-list-second"
              : props.data.level === 3
                ? "ledger-list-third"
                : "ledger-list-fourth"
            }`}
        >
          <li>{props.children}</li>
        </ul>
      </components.Option>
    );
  };

  // Final return
  return (
    <Modal isOpen={isOpen} toggle={toggleAddFolderModal} backdrop="static" >
      <ModalHeader className="pt-4 pl-4">
        {`${isEdit ? "Edit" : "Add"} Account Details`}
      </ModalHeader>
      <ModalBody className="pl-4 pr-4" style={{ paddingLeft: "40px" }}>
        <form>
          <span className="form-group">
            <label
              htmlFor="accountNumber"
              className={modeSelected ? "active" : ""}
            >
              Select Account Type<span className='color-red'>*</span>
            </label>
          </span>
        </form>
        <div style={{ width: "53%" }}>
          <DropDown
            options={MODE_TYPE}
            handleChange={handleChangeSelectedMode}
            value={modeSelected}
          />
        </div>
        {toShowSubAccount && (
          <>
            <form className="mt-3">
              <span className="form-group">
                <label
                  htmlFor="accountNumber"
                  className={parentAccount ? "active" : ""}
                >
                  Select Parent Account<span className='color-red'>*</span>
                </label>
              </span>
            </form>
            <div className="ledger-dropdown" style={{ width: "53%" }}>
              <Select<AllLedgersListType, false>
                classNamePrefix="react-select"
                inputProps={{ autoComplete: "nope" }}
                options={finalLedgerList}
                className={`react-select`}
                value={parentAccount}
                onChange={handleChangeParentAccount}
                isSearchable
                components={{ Option }}
              />
              {!!accountDetailsError?.parentAccountError && (
                <small className="text-danger">
                  {accountDetailsError?.parentAccountError}
                </small>
              )}
            </div>
          </>
        )}
        <form>
          <div className="form-group mt-3">
            <div style={{ width: "53%" }}>
              <label
                htmlFor="accountName"
                className={accountName ? "active" : ""}
              >
                Enter Account Name<span className='color-red'>*</span>
              </label>
              <input
                type="text"
                className={`form-control ${!!accountNameError ? "error-border" : null
                  }`}
                name="accountName"
                value={accountName}
                onChange={(e) => handleAccountDetailsChange(e)}
                maxLength={150}
                disabled={!!accountDetailsError?.parentAccountError}
              // onKeyPress={(e: any) => e.key === 'Enter' ? handleAddFolder(e) : null}
              />
              {!!accountNameError && (
                <small className="text-danger">{accountNameError}</small>
              )}
            </div>
            <span className="input-length">
              {returnInputFieldLength(accountName?.length, 150)}
            </span>
          </div>
        </form>
        <div className="d-flex mt-3 mb-3">
          <Checkbox checked={toShowSubAccount} onPress={toggleCheckbox} />
          <small className="ml-2">Make this a sub-account</small>
        </div>
        {!autoUniqueNumberCheck || isEdit ? (
                  <form>
                  <div className="form-group mt-3">
                    <div style={{ width: "53%" }}>
                      <label
                        htmlFor="accountNumber"
                        className={accountNumber ? "active" : ""}
                      >
                        Enter Account Number<span className='color-red'>*</span>
                      </label>
                      <div className="d-flex flex-row position-relative">
                        <input
                          type="number"
                          className={`form-control ${!!accountNumberError ? "error-border" : null
                            }`}
                          name="accountNumber"
                          value={accountNumber}
                          autoFocus
                          onChange={(e) => handleAccountDetailsChange(e)}
                          maxLength={12}
                          onInput={handleMaxLengthCheck}
                          onWheel={event => event.currentTarget.blur()}
                          disabled={autoUniqueNumberCheck && isEdit}
                          />
                        {uniqueLedgerFetching && <RollingLoader />}
                      </div>
                      {!!accountNumberError && (
                        <small className="text-danger">{accountNumberError}</small>
                      )}
                      {ledgerApiMessage?.includes("not") && !!accountNumber?.length && (
                        <small className="text-danger">
                          Account number is already in use!
                        </small>
                      )}
                    </div>
                    <span className="input-length">
                      {returnInputFieldLength(accountNumber?.length, 12)}
                    </span>
                  </div>
                </form>
        ) : null}

        <form className="mt-3">
          <span className="form-group">
            <label
              htmlFor="accountNumber"
            // className={toShowLedger ? "active" : ""}
            >
              Do you want to show this account in Account List?
            </label>
          </span>
        </form>
        <div className="mt-2 mb-4">
          <RadioContainer
            optionsList={RADIO_OPTIONS}
            handleSetRadioValue={handleSetRadioValue}
            radioValue={toShowLedger}
          />
        </div>
        {(modeSelected?.value === "nature_of_income" || modeSelected?.value === "nature_of_expense") && <>
          <form className="mt-3">
            <span className="form-group">
              <label
                htmlFor="accountNumber"
              >

                Cost Of Goods Type
              </label>
            </span>
          </form>
          {(editAccountDetailsData?.parent_id === 0 || editAccountDetailsData?.parent_id === undefined) && (!parentAccount?.value) ? <div className="mt-2 mb-4">
            <RadioContainer
              optionsList={ACCOUNT_RADIO_OPTIONS}
              handleSetRadioValue={handleSetCostOfGoodsRadioValue}
              radioValue={costOfGoods}
            />
          </div> : parentAccount?.value ? parentAccount?.cog === 2 ? "Indirect" : "Direct" : editAccountDetailsData?.cog_type === 2 ? "Indirect" : "Direct"}
        </>}
      </ModalBody>
      <ModalFooter>
        <span
          className="pointer"
          onClick={() => {
            toggleAddFolderModal();
            handleResetEditData();
            handleResetData();
            setAccountDetailsError((prevState) => ({
              ...prevState,
              accountNumberError: "",
            }));
          }}
        >
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleSubmitAccountDetails()
            handleResetEditData();
          }
          }
          disabled={
            !!accountDetailsError?.parentAccountError || !ledgerType?.length || accountName?.length==0 ||
            (toShowSubAccount && parentAccount?.value === null)
          }
        >
          {isEdit ? "Update Details" : "Add Details"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  ledgerMessage: state.clientSettings.ledgerMessage,
  uniqueLedgerFetching: state.clientSettings.uniqueLedgerFetching,
  success: state.clientSettings.success,
  error: state.clientSettings.error,
  allLedgersList: state.clientSettings.singleTypeLedgerList,
});

const mapDispatchToProps = (dispatch: any) => ({

  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),

  dispatchResetClientSettingsError: () =>
    dispatch(resetClientSettingsError()),

  dispatchCheckUniqueLedgerAction: (data: CheckUniqueLedgerPayloadType) =>
    dispatch(checkUniqueLedgerAction(data)),

  dispatchGetAllLedgersListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getSingleTypeLedgerListAction(data)),

  dispatchResetSingleTypeLedgerListAction: () =>
    dispatch(resetSingleTypeLedgersList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAccountModal);
